import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import CollabrativeImg from "../../Assets/Images/CollabrativeImg.png";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20, 
    flex: 1,
  },
  card: {
    marginBottom: 5, 
  },
  cardBlue: {
    backgroundColor: "#F1F8F1",
    padding: 10,
    borderRadius: 5,
    marginTop: "2px"
  },
  cardRed: {
    backgroundColor: "#FFF0EC",
    padding: 10,
    borderRadius: 5,
    marginTop: "2px"
  },
  title: {
    fontSize: "18px",
    lineHeight: "21px",
    fontWeight: "700",
    fontFamily: "Lato",
    color: "#426B88",
    marginBottom: "10px", 
    textAlign: "left",
  },
  subtitle: {
    fontSize: 12,
    fontFamily: "Lato",
    fontWeight: "700",
    color: "#00577D",
    lineHeight: "18px",
    marginBottom: 4,
  },
  paragraph: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: "700",
    color: "#00577D",
  },
  listItem: {
    fontSize: "12px",
    color: "#00577D",
    fontFamily: "Lato",
    lineHeight: "18px",
    fontWeight: "400",
    marginBottom: 2,
  },
  coverImage: {
    width: "72px", 
    height: "72px",
    marginRight: 10,
    resizeMode: "contain",
  },
  first: {
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    //  flex: 1, 
    fontSize: "12px",
    fontFamily: "Lato",
    lineHeight: "18px",
    fontWeight: "400",
    color: "#00577D",
  },
});

const LeadershipStyleCollaborative360 = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        YOU REFLECT A COLLABORATIVE LEADERSHIP STYLE (360 RESULTS)
      </Text>

      <View style={styles.card}>
        <View style={styles.first}>
          <Image src={CollabrativeImg} style={styles.coverImage} />
          <Text style={styles.text}>
            Collaborative Leadership is an extension of the Heart quadrant.
            These types of leaders excel in creating environments where everyone
            feels important and valued. They lead in ways that foster a
            cooperative atmosphere and emphasize respect among team members,
            helping everyone perform their best.
          </Text>
        </View>
        <Text style={styles.text}>
        Often referred to as "the People’s Leader," these individuals focus
        first on relationships and may be naturally attuned to understanding and
        constructively managing the feelings, wants, and needs happening beneath
        the surface. This makes them empathetic and considerate, but they need
        to be careful not to get too caught up in people's issues to the point
        where it derails objectives and overrides healthy boundaries. At the
        heart of collaborative leadership is the belief that working together
        brings better results than working alone: "If you want to go fast, go
        alone. If you want to go far, go together."
      </Text>
      </View>


      <View style={styles.cardBlue}>
        <Text style={styles.subtitle}>
          POSSIBLE CONTRIBUTIONS OF A COLLABORATIVE LEADER:
        </Text>
        <Text style={styles.listItem}>
          • Empowering Team Members: Collaborative leaders delegate authority
          and encourage initiative, boosting team confidence and accountability.
        </Text>
        <Text style={styles.listItem}>
          • Interdepartmental Cooperation: They can bridge departmental gaps,
          aligning diverse interests and goals for enhanced cooperation and
          reduced silos.
        </Text>
        <Text style={styles.listItem}>
          • Stakeholder Engagement: Effective at engaging stakeholders like
          customers and suppliers, their approach builds trust and fosters
          strong relationships crucial for success.
        </Text>
        <Text style={styles.listItem}>
          • Cultural Development: These leaders foster a positive culture
          valuing teamwork, respect, and diversity, making the workplace more
          welcoming and productive.
        </Text>
        <Text style={styles.listItem}>
          • Enhanced Morale and Job Satisfaction: Their leadership boosts job
          satisfaction and morale, making employees feel valued and reducing
          turnover.
        </Text>
      </View>

      <View style={styles.cardRed}>
        <Text style={styles.subtitle}>
          POSSIBLE CHALLENGES FOR A COLLABORATIVE LEADER:
        </Text>
        <Text style={styles.listItem}>
          • Risk of Groupthink: Emphasizing consensus may lead to groupthink,
          where the desire for harmony results in irrational or dysfunctional
          decisions.
        </Text>
        <Text style={styles.listItem}>
          • Decision-Making Delays: The consensus-driven approach can slow down
          decision-making, especially in critical situations.
        </Text>
        <Text style={styles.listItem}>
          • Maintaining Objectivity: With a focus on relationships and feelings,
          there's a risk of losing objectivity and becoming overly involved in
          personal issues.
        </Text>
        <Text style={styles.listItem}>
          • Underperformance: Addressing underperformance can be challenging as
          they prioritize maintaining positive relationships.
        </Text>
        <Text style={styles.listItem}>
          • Resource Demands: Collaborative approaches often require more time
          and resources, which can challenge resource management without
          compromising other areas.
        </Text>
      </View>
    </View>
  );
};

export default LeadershipStyleCollaborative360;
